import React from 'react';
import { Card, List, Tag } from 'antd';

const RealTimeActivityFeed = ({ events = [] }) => {
  const rows = Array.isArray(events) ? events : [];
  return (
    <Card title="Real-time Activity Feed">
      <List
        dataSource={rows.slice(0, 20)}
        locale={{ emptyText: 'No live events yet' }}
        renderItem={(item) => (
          <List.Item>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <Tag color="blue">{String(item?.type || 'event')}</Tag>
              <span>{String(item?.message || item?.summary || 'Activity update')}</span>
            </div>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default RealTimeActivityFeed;

